<!-- Address Form Dialog -->
<hlm-dialog [state]="isOpen() ? 'open' : 'closed'" (closed)="onClose()">
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    class="w-full max-w-3xl min-w-[680px] h-[640px] max-h-[90vh] flex flex-col"
  >
    <app-wizard-dialog-header
      eyebrow="Adresse"
      [title]="editAddress() ? 'Adresse bearbeiten' : 'Neue Adresse erstellen'"
      [steps]="wizardSteps()"
      (stepJump)="jumpToStep($any($event.id))"
    />

    <div hlmSeparator class="my-2"></div>
    <div class="flex-1 py-4 relative w-full min-h-0">
      <div class="h-full w-full overflow-hidden">
        <div class="h-full overflow-y-auto animate-in fade-in-50 duration-300 px-1">
          <app-step-lead [text]="stepLead()" />

          <form [formGroup]="form">
            <!-- Step 1: Address data -->
            @if (currentStep() === 1) {
              <div class="grid grid-cols-3 gap-5">
                <div class="col-span-2">
                  <app-suffix-input
                    label="Straße"
                    inputType="text"
                    formControlName="street"
                    required
                    [errorText]="getFieldError('street')"
                  />
                </div>
                <app-suffix-input
                  label="Hausnummer"
                  inputType="text"
                  formControlName="houseNumber"
                  required
                  [errorText]="getFieldError('houseNumber')"
                />
                <app-suffix-input
                  label="PLZ"
                  inputType="text"
                  formControlName="postalCode"
                  required
                  [errorText]="getFieldError('postalCode')"
                />
                <div class="col-span-2">
                  <app-suffix-input
                    label="Ort"
                    inputType="text"
                    formControlName="city"
                    required
                    [errorText]="getFieldError('city')"
                  />
                </div>

                <app-select-field
                  label="Dachtyp (optional)"
                  placeholder="Auswählen"
                  [options]="roofTypes"
                  formControlName="roofType"
                />
                <app-select-field
                  label="Gebäudetyp (optional)"
                  placeholder="Auswählen"
                  [options]="buildingTypes"
                  formControlName="buildingType"
                />
                <app-select-field
                  label="Solaranlage (optional)"
                  placeholder="Auswählen"
                  [options]="solarOptions"
                  formControlName="solarStatus"
                />
              </div>
            }

            <!-- Step 2: Summary -->
            @if (currentStep() === 2) {
              <app-summary-section title="Adressdaten" (edit)="jumpToStep(1)">
                <app-summary-row label="Straße" [value]="summaryStreet()" />
                <app-summary-row label="PLZ, Ort" [value]="summaryCity()" mono />
                <app-summary-row label="Dachtyp" [value]="summaryRoofType()" />
                <app-summary-row label="Gebäudetyp" [value]="summaryBuildingType()" />
                <app-summary-row label="Solaranlage" [value]="summarySolar()" />
              </app-summary-section>
            }
          </form>

          <!-- Error Message -->
          @if (error()) {
            <div class="mt-4 px-3.5 py-3 bg-destructive/10 border border-destructive/20 rounded-lg">
              <p class="text-sm text-destructive">{{ error() }}</p>
            </div>
          }
        </div>
      </div>
    </div>

    <div hlmSeparator></div>
    <app-wizard-dialog-footer
      [currentStep]="currentStep()"
      [totalSteps]="2"
      [isFirstStep]="currentStep() === 1"
      [isLastStep]="currentStep() === 2"
      [canProceed]="currentStep() === 1 ? form.valid : !isSubmitting()"
      [isSubmitting]="isSubmitting()"
      [submitLabel]="editAddress() ? 'Adresse aktualisieren' : 'Adresse speichern'"
      (back)="prevStep()"
      (next)="nextStep()"
      (submit)="onSubmit()"
      (cancel)="onClose()"
    />
  </hlm-dialog-content>
</hlm-dialog>
